import { CONTACT } from "../data/projects";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-ivory px-6 py-16 sm:px-10">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div>
          <h3 className="font-serif text-4xl leading-none text-ink sm:text-5xl">Pavitra Mishra</h3>
          <p className="mt-3 text-xs uppercase tracking-[0.22em] text-ink-soft">
            Founder &amp; Head Chef, We Cook Art
          </p>
        </div>

        <div className="flex flex-col gap-2 md:items-end">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email-link"
            className="text-sm text-ink-soft transition-colors hover:text-oxblood"
          >
            {CONTACT.email}
          </a>
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="text-sm text-ink-soft transition-colors hover:text-oxblood"
          >
            Instagram — {CONTACT.instagramHandle}
          </a>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-[1600px] flex-col gap-2 border-t border-line pt-6 text-[0.7rem] uppercase tracking-[0.22em] text-ink-soft sm:flex-row sm:justify-between">
        <span className="italic normal-case tracking-normal font-serif text-base text-gold">Keep Cooking Art.</span>
        <span>&copy; {year} We Cook Art — All frames held with care.</span>
      </div>
    </footer>
  );
};

export default Footer;
